import { Badge } from '@frontend/components';

type CustomCategoryBadgeProps = {
  name?: string;
  color?: string;
};

export const CustomCategoryBadge = ({
  name,
  color,
  ...rest
}: CustomCategoryBadgeProps) => {
  if (!color || !name) {
    return null;
  }

  return (
    <Badge bgColor={color} borderColor={color} {...rest}>
      {name}
    </Badge>
  );
};
